// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Vy69DSs0nkgt_0Lf3efy{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}html[dir] .Vy69DSs0nkgt_0Lf3efy{background-color:var(--neutralLighterAlt)}html[dir] .Vy69DSs0nkgt_0Lf3efy:focus{border:dotted 1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Vy69DSs0nkgt_0Lf3efy"
};
module.exports = ___CSS_LOADER_EXPORT___;
